import React from "react";
import Link from "../../Link";
import cx from "classnames";

const LatestPostCard = ({ className, post }) => {
  return post ? (
    <div
      className={cx(
        "latest-post-card align-items-stretch shadow rounded mx-2",
        className
      )}
      style={{ maxWidth: 250 }}
    >
      <Link to={`/learn/${post.slug}/`}>
        <div className="position-relative">
          <img
            className="card-img-top"
            src={post.featuredImage.node.localFile.publicURL}
            alt={""}
            width={250}
            loading="lazy"
          />
          <div
            className="position-absolute badge px-2"
            style={{
              top: "8%",
              right: "7%",
              backgroundColor: "#FA4764",
              color: "#FFFFFF",
              fontSize: "12px",
            }}
          >
            NEW
          </div>
        </div>

        <div className="card-body mt-1 pt-2">
          <h6 className="custom-header-truncate">{post.title}</h6>

          <div className="d-flex align-items-center mt-1">
            <div style={{ color: "#21bdca" }}>Articles</div>
            <div className="ml-1" style={{ color: "#8B949D" }}>
              &bull; {post.date}
            </div>
          </div>
        </div>
      </Link>
    </div>
  ) : null;
};

export default LatestPostCard;
